/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { UsersBaseService } from '../users-base-service';
import { UsersApiConfiguration } from '../users-api-configuration';
import { UsersStrictHttpResponse } from '../users-strict-http-response';

import { appControllerHandleEvent } from '../fn/events/app-controller-handle-event';
import { AppControllerHandleEvent$Params } from '../fn/events/app-controller-handle-event';

@Injectable({ providedIn: 'root' })
export class UsersEventsService extends UsersBaseService {
  constructor(config: UsersApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `appControllerHandleEvent()` */
  static readonly AppControllerHandleEventPath = '/o2-users/events';

  /**
   * Process events from Rocket (EventBridge) and Cognito (SQS).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `appControllerHandleEvent()` instead.
   *
   * This method doesn't expect any request body.
   */
  appControllerHandleEvent$Response(params?: AppControllerHandleEvent$Params, context?: HttpContext): Observable<UsersStrictHttpResponse<void>> {
    const obs = appControllerHandleEvent(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Process events from Rocket (EventBridge) and Cognito (SQS).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `appControllerHandleEvent$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  appControllerHandleEvent(params?: AppControllerHandleEvent$Params, context?: HttpContext): Observable<void> {
    const resp = this.appControllerHandleEvent$Response(params, context);
    return resp.pipe(
      map((r: UsersStrictHttpResponse<void>): void => r.body)
    );
  }

}
